import { FormControl, Input, MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { Button } from "../../Utils/Button";
import { Dialog } from "../../Utils/Dialog";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.common.black,
      marginRight: "10px",
    },
    value: {
      color: theme.palette.primary.main,
      marginRight: "20px",
    },
    dialogContainer: {
      display: "flex",
      flexWrap: "wrap",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    button: {
      color: theme.palette.common.white,
    },
  }),
);

interface ListSelectProps {
  title: string;
  value: string;
  list: string[];
  logId: number;
  onDisplayValue: (val: any) => string;
  setValue: (value: string) => void;
}

export const ListSelect: React.FC<ListSelectProps> = (props) => {
  const classes = useStyles();
  const { value, logId } = props;
  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState(value);

  useEffect(() => {
    setSelection(value === null ? "unknown" : value);
  }, [value, setSelection]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelection(event.target.value as string);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    props.setValue(selection);
    handleClose();
  };

  return (
    <>
      <span className={classes.title}>{props.title}</span>
      <span className={classes.value}>
        {props.onDisplayValue(props.value)}{" "}
        <Button size="small" color="primary" variant="outlined" onClick={handleClickOpen}>
          Update value
        </Button>
      </span>
      {open && (
        <Dialog
          title={`Update value for log ${logId}`}
          action={"Save"}
          open={open}
          onClose={handleClose}
          onConfirm={handleSave}
        >
          <form className={classes.dialogContainer}>
            <FormControl className={classes.formControl}>
              <Select displayEmpty value={selection} onChange={handleChange} input={<Input />}>
                {props.list.map((element) => {
                  return (
                    <MenuItem key={element} value={element}>
                      {props.onDisplayValue(element)}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </form>
        </Dialog>
      )}
    </>
  );
};
